import LocalStorageService from './localStorageService';

export default class APIService {
  private baseURL: string;
  private localStorageService: LocalStorageService;

  constructor() {
    this.baseURL = process.env.VUE_APP_API_BASE_URL || 'http://localhost:7979/api';
    this.localStorageService = new LocalStorageService();
  }

  public getRequest(endpoint: string): Promise<Response> {
    return fetch(this.getFullURL(endpoint), this.getFullOptions('GET'));
  }

  public postRequest(endpoint: string, bodyJSON?: any): Promise<Response> {
    const bodyString: string | undefined = (bodyJSON) ? JSON.stringify(bodyJSON) : undefined;
    return fetch(
      this.getFullURL(endpoint),
      this.getFullOptions('POST', bodyString)
    );
  }

  public putRequest(endpoint: string, bodyJSON: any): Promise<Response> {
    return fetch(
      this.getFullURL(endpoint),
      this.getFullOptions('PUT', JSON.stringify(bodyJSON))
    );
  }

  public deleteRequest(endpoint: string): Promise<Response> {
    return fetch(this.getFullURL(endpoint), this.getFullOptions('DELETE'));
  }

  private getFullURL(endpoint: string): string {
    return this.baseURL + endpoint;
  }

  private getFullOptions(method: string, body?: string) {
    const options: any = {
      method: method,
      headers: {
        'Content-Type': 'application/json'
      }
    };

    const accessToken = this.localStorageService.getAccessToken();
    if (accessToken) {
      options.headers.Authorization = `Bearer ${accessToken}`;
    }

    if (body) {
      options.body = body;
    }

    return options;
  }
}
